<div cdkDropList [cdkDropListData]="items" (cdkDropListDropped)="drop($event)" cdkDropListConnectedTo="Suite"
    class="exe-container"
    [ngClass]="{'pullOver':lockStatus=='lock_open','pullingLocked':lockStatus=='lock','pulled':executionModel.suite_id!=undefined,'dialog-container':isDialog}">
    <div class="hoverText" *ngIf="executionModel.suite_id==undefined && !forceOpen">
        <div class="container23">
          <div class="text">
                Execution Panel
            </div>  
        </div>
    </div>
    <div [hidden]="executionModel.suite_id==null && !forceOpen" fxflex="50%">
        <div class="executionContainer">
            <div class="execution">
                <h3 class="executionHeading">
                    <span *ngIf="!hideSuiteName && dropped_suite?._type" class="execution_heading">{{ dropped_suite._type }} :</span>
                    <span *ngIf="!hideSuiteName">{{ dropped_suite?.name }}</span>
                </h3>
                <mat-icon *ngIf="!isDialog && !hideControls && !hideCloseIcon" (click)="resetAll()">cancel</mat-icon>
            </div>
            <div class="row2">
                <div *ngIf="!hideUpload && showDiv && isParametersAvailable && isDefaultCsvFile && isDialog"
                    class="file-upload-container default-csv-container">
                    Default CSV
                </div>
                <div *ngIf="!hideUpload && showDiv && isParametersAvailable && (!isDefaultCsvFile || !isDialog)">
                    <!-- Edit + schedule has CSV in attached_files: show file name + Reset -->
                    <ng-container *ngIf="editMode && scheduleAttachedCsvPath">
                        <div *ngIf="useDefaultCsv" class="attached-csv-info">
                            <span class="attached-csv-file">Attached file</span>
                            <button type="button" mat-button color="primary" class="attached-csv-reset"
                                (click)="resetScheduleAttachedCsv()">
                                Reset
                            </button>
                        </div>
                        <ng-container *ngIf="!useDefaultCsv">
                            <mat-radio-group *ngIf="hasSuiteCsv" [(ngModel)]="useDefaultCsv" class="resource-toggle">
                                <mat-radio-button [value]="true">Use Suite Default</mat-radio-button>
                                <mat-radio-button [value]="false">Upload New CSV</mat-radio-button>
                            </mat-radio-group>
                            <div *ngIf="!useDefaultCsv" class="upload-zone">
                                <ze-file-upload-dn-d (file)="fileAdded($event)" [reset]="resetFile"
                                    (onReset)="resetUploadedFile($event)" class="file">
                                </ze-file-upload-dn-d>
                                <mat-checkbox *ngIf="!hideSetCsv" [(ngModel)]="setCsvForSuite" class="set-default-check">
                                    Set CSV as suite default
                                </mat-checkbox>
                            </div>
                        </ng-container>
                    </ng-container>

                    <!-- Edit without schedule CSV, or create: suite has default CSV — radio toggle -->
                    <ng-container *ngIf="hasSuiteCsv && (!editMode || !scheduleAttachedCsvPath)">
                        <mat-radio-group [(ngModel)]="useDefaultCsv" class="resource-toggle">
                            <mat-radio-button [value]="true">Use Suite Default</mat-radio-button>
                            <mat-radio-button [value]="false">Upload New CSV</mat-radio-button>
                        </mat-radio-group>
                        <div *ngIf="!useDefaultCsv" class="upload-zone">
                            <ze-file-upload-dn-d (file)="fileAdded($event)" [reset]="resetFile"
                                (onReset)="resetUploadedFile($event)" class="file">
                            </ze-file-upload-dn-d>
                            <mat-checkbox *ngIf="!hideSetCsv" [(ngModel)]="setCsvForSuite" class="set-default-check">
                                Set CSV as suite default
                            </mat-checkbox>
                        </div>
                    </ng-container>

                    <!-- No suite CSV: upload directly (skip when edit mode still has schedule-attached CSV) -->
                    <ng-container *ngIf="!hasSuiteCsv && !(editMode && scheduleAttachedCsvPath)">
                        <div class="upload-zone">
                        <ze-file-upload-dn-d (file)="fileAdded($event)" [reset]="resetFile"
                            (onReset)="resetUploadedFile($event)" class="file">
                        </ze-file-upload-dn-d>
                        <mat-checkbox *ngIf="!hideSetCsv" [(ngModel)]="setCsvForSuite" class="set-default-check">
                            Set CSV as suite default
                        </mat-checkbox>
                        </div>
                    </ng-container>
                </div>
                <div class="column execution-container">
                    <div class="outer-border">
                        <form class="example-form">
                            <div class="exe_container_top">
                                <mat-form-field class="example-full-width">
                                    <mat-label>Execution Type</mat-label>
                                    <mat-select name="executionType" [(ngModel)]="selectedExecutionTypes"
                                        (selectionChange)="onExecutionTypeChange()" multiple>
                                        <mat-option *ngIf="showWebExecutionType()" [value]="'web'" [disabled]="disableWebExecutionType()">
                                            Web
                                        </mat-option>
                                        <mat-option *ngIf="showMobileExecutionType()" [value]="'mobile'" [disabled]="disableMobileExecutionType()">
                                            Mobile
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div #webHostDropdown class="editable-dropdown" *ngIf="isWebExecution()">
                                    <input type="text" name="webLocalHost" [(ngModel)]="selectedOption"
                                        [disabled]='this.executionModel.default_hub || inputboxDisables'
                                        [placeholder]="brand.brandName + ' Cloud'"
                                        [ngClass]="{'red-placeholder': this.executionModel.default_hub, 'black-placeholder': !this.executionModel.default_hub}" />
                                    <span class="dropdown-icon" (click)="toggleDropdown(!showDropdown)">
                                        <i class="arrow" [class.down]="!showDropdown" [class.up]="showDropdown"
                                            [ngClass]="{ 'disarrow': this.executionModel.default_hub }"></i>
                                    </span>
                                    <ul *ngIf="showDropdown" class="dropdown-options">
                                        <label *ngIf="!isLocalExecutionBlocked">Developer System</label>
                                        <ng-container *ngIf="!isLocalExecutionBlocked">
                                            <li class="onlineStatus" *ngFor="let option of listofUser"
                                                (click)="!isStatusInactive(option.localExecutionModels[0]?.last_active_time) && selectOption(option)"
                                                [class.disabled]="isStatusInactive(option.localExecutionModels[0]?.last_active_time)">

                                                <div>
                                                    <div class="opt_left">
                                                        {{option.username}}
                                                    </div>
                                                    <div class="opt_right">
                                                        Last updated time:<br>
                                                        {{
                                                        convertEpochToDate(option.localExecutionModels[0]?.last_active_time)
                                                        }}<br>
                                                        <span [ngClass]="{
                    'status-inactive': isStatusInactive(option.localExecutionModels[0]?.last_active_time),
                    'status-active': !isStatusInactive(option.localExecutionModels[0]?.last_active_time)
                    }">
                                                            Status:
                                                            {{
                                                            isStatusInactive(option.localExecutionModels[0]?.last_active_time)
                                                            ? 'Inactive'
                                                            : 'Active'
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>

                                            <li *ngIf="listofUser.length === 0" class="no-options">
                                                No host found.
                                            </li>
                                        </ng-container>
                                        <li (click)="selectOptionforCustom(CustomeIP)">Custom IP</li>
                                    </ul>
                                </div>
                                <!-- mobile local execution (same pattern as web; API type `mobile`) -->
                                <div #mobileHostDropdown class="editable-dropdown"
                                    *ngIf="isMobileExecution() && !runOnXpeerMobileHub">
                                    <input type="text" name="mobileLocalHost" [(ngModel)]="selectedOption"
                                        [disabled]="inputboxDisables" [placeholder]="brand.brandName + ' Mobile Cloud'"
                                        [ngClass]="{'red-placeholder': inputboxDisables, 'black-placeholder': !inputboxDisables}" />
                                    <span class="dropdown-icon" (click)="toggleMobileDropdown(!showMobileDropdown)">
                                        <i class="arrow" [class.down]="!showMobileDropdown"
                                            [class.up]="showMobileDropdown"></i>
                                    </span>
                                    <ul *ngIf="showMobileDropdown" class="dropdown-options">
                                        <label *ngIf="!isLocalExecutionBlocked">Developer System</label>
                                        <ng-container *ngIf="!isLocalExecutionBlocked">
                                            <li class="onlineStatus" *ngFor="let option of listofUserMobile"
                                                (click)="!isStatusInactive(option.localExecutionModels[0]?.last_active_time) && selectOption(option, true)"
                                                [class.disabled]="isStatusInactive(option.localExecutionModels[0]?.last_active_time)">

                                                <div>
                                                    <div class="opt_left">
                                                        {{option.username}}
                                                    </div>
                                                    <div class="opt_right">
                                                        Last updated time:<br>
                                                        {{
                                                        convertEpochToDate(option.localExecutionModels[0]?.last_active_time)
                                                        }}<br>
                                                        <span [ngClass]="{
                    'status-inactive': isStatusInactive(option.localExecutionModels[0]?.last_active_time),
                    'status-active': !isStatusInactive(option.localExecutionModels[0]?.last_active_time)
                    }">
                                                            Status:
                                                            {{
                                                            isStatusInactive(option.localExecutionModels[0]?.last_active_time)
                                                            ? 'Inactive'
                                                            : 'Active'
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>

                                            <li *ngIf="listofUserMobile.length === 0" class="no-options">
                                                No host found.
                                            </li>
                                        </ng-container>
                                        <li (click)="selectOptionforCustom(CustomeIP, true)">Custom IP</li>
                                    </ul>
                                </div>

                                <mat-form-field [class.disabled]="this.executionModel.default_hub"
                                    class="example-full-width" *ngIf="isWebExecution()">
                                    <mat-label>Port</mat-label>
                                    <div class="topport">
                                        <input matInput name="port"
                                            [ngModel]="executionModel.default_hub ? 'Default Port' : executionModel.port"
                                            (ngModelChange)="!executionModel.default_hub && (executionModel.port = $event)"
                                            [placeholder]="executionModel.default_hub ? 'Default Port' : ''"
                                            [disabled]="(_isURLWithoutPORT || executionModel.default_hub)?true:null">
                                        <mat-checkbox class="check-box custom-checkbox" name="isPortCheckbox"
                                            matTooltip="is URL without port"
                                            [(ngModel)]="_isURLWithoutPORT"></mat-checkbox>
                                    </div>
                                </mat-form-field>
                                <ng-container *ngIf="isWebExecution()">
                                    <mat-form-field>
                                        <mat-label>Browsers</mat-label>
                                        <mat-select name="browsers" [(ngModel)]="executionModel.browser"
                                            (selectionChange)="onBrowserChange()" multiple>
                                            <mat-option *ngFor="let browser of browserList"
                                                [value]="browser">{{browser}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Screen Resolution</mat-label>
                                        <mat-select name="screenResolution" [(ngModel)]="executionModel.resolution">
                                            <mat-option *ngFor="let scrResolution of resolutionList"
                                                [value]="scrResolution.value">{{scrResolution.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field class="resolution-form-field"
                                        *ngIf="executionModel.resolution === 'custom_resolution'">
                                        <mat-label>X Dimension:</mat-label>
                                        <input matInput type="number" id="xDimension" name="xDimension"
                                            [(ngModel)]="xDimension" min="250" max="4000">
                                    </mat-form-field>
                                    <mat-form-field class="resolution-form-field"
                                        *ngIf="executionModel.resolution === 'custom_resolution'">
                                        <mat-label>Y Dimension:</mat-label>
                                        <input matInput type="number" id="yDimension" name="yDimension"
                                            [(ngModel)]="yDimension" min="250" max="4000">
                                    </mat-form-field>
                                </ng-container>

                                <mat-form-field>
                                    <mat-label>Delay in second</mat-label>
                                    <mat-select name="delay" [(ngModel)]="executionModel.default_pause"
                                        (ngModelChange)="onDefaultPauseChange($event)">
                                        <mat-option *ngFor="let delay of delayList" [value]="delay.value">{{delay.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field *ngIf="showAiIntelligenceDropdown">
                                    <mat-label>AI Intelligence</mat-label>
                                    <mat-select name="aiIntelligence" [(ngModel)]="selectedAiIntelligence">
                                        <mat-option *ngFor="let option of visibleAiIntelligenceOptions" [value]="option.value"
                                            [disabled]="isAiIntelligenceOptionDisabled(option)">{{option.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <ng-container *ngIf="showMobileDeviceAndApkPanel && !hideMobileDevice">
                                    <div style="display: flex; align-items: center; gap: 8px;">
                                        <mat-form-field>
                                            <mat-label>Mobile Device</mat-label>
                                            <mat-select name="emulator" [(ngModel)]="selectedEmulators"
                                                (selectionChange)="onEmulatorSelect($event.value)" multiple>
                                                <mat-option *ngFor="let emulator of emulatorList" [value]="emulator"
                                                    [disabled]="isEmulatorOptionDisabled(emulator)">
                                                    <div style="display: flex; align-items: center; gap: 8px;">
                                                        <!-- Status Circle -->
                                                        <span class="status-dot"
                                                            [ngClass]="getStatusClass(emulator.status, emulator.sessionStatus)"></span>
                                                        <!-- Label -->
                                                        <div matTooltip="{{ emulator.domain }} - {{ emulator.device_name }} - {{ emulator.executions_queued }}" matTooltipPosition="above" title="{{ emulator.domain }} - {{ emulator.device_name }} - {{ emulator.executions_queued }}">
                                                            {{ emulator.domain }} - {{ emulator.device_name }} - {{
                                                            emulator.executions_queued}}
                                                        </div>
                                                    </div>
                                                </mat-option>
                                                <mat-option *ngIf="emulatorList.length === 0" disabled>
                                                    No emulators (waiting for status…)
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <!-- Hidden file input: always present while mobile mode is active -->
                                    <input #apkInput type="file" accept=".apk"
                                        (change)="onApkFileSelected(apkInput)" hidden />

                                    <!-- APK controls — shown only after an emulator is selected -->
                                    <div *ngIf="selectedEmulators?.length > 0" class="apk-controls">

                                        <!-- Edit + schedule has APK in attached_files -->
                                        <ng-container *ngIf="editMode && scheduleAttachedApkPath">
                                            <div *ngIf="useDefaultApk && !apkFile" class="apk-file-chip schedule-apk-chip">
                                                <span class="material-symbols-outlined" aria-hidden="true">android</span>
                                                <span class="apk-file-chip__name">Attached file</span>
                                                <button type="button" mat-button color="primary" class="attached-csv-reset"
                                                    (click)="resetScheduleAttachedApk(apkInput)">
                                                    Reset
                                                </button>
                                            </div>
                                            <ng-container *ngIf="!useDefaultApk">
                                                <mat-radio-group *ngIf="hasSuiteApk" name="apkSource"
                                                    [(ngModel)]="useDefaultApk"
                                                    (ngModelChange)="onUseDefaultApkChange($event, apkInput)"
                                                    class="resource-toggle">
                                                    <mat-radio-button [value]="true">Use Suite Default</mat-radio-button>
                                                    <mat-radio-button [value]="false">Upload New APK</mat-radio-button>
                                                </mat-radio-group>
                                            </ng-container>
                                        </ng-container>

                                        <!-- Create, or edit without schedule APK: radio when suite has default APK -->
                                        <mat-radio-group *ngIf="(!editMode || !scheduleAttachedApkPath) && hasSuiteApk"
                                                         name="apkSource"
                                                         [(ngModel)]="useDefaultApk"
                                                         (ngModelChange)="onUseDefaultApkChange($event, apkInput)"
                                                         class="resource-toggle">
                                            <mat-radio-button [value]="true">Use Suite Default</mat-radio-button>
                                            <mat-radio-button [value]="false">Upload New APK</mat-radio-button>
                                        </mat-radio-group>

                                        <ng-container *ngIf="showApkUploadZone()">

                                            <!-- No file selected yet: show clickable upload zone -->
                                            <div *ngIf="!apkFile" class="apk-drop-zone" (click)="apkInput.click()">
                                                <span>Upload APK</span>
                                            </div>

                                            <!-- File selected: show chip with filename + remove button -->
                                            <div *ngIf="apkFile" class="apk-file-chip">
                                                <span class="apk-file-chip__name">{{ apkFileName }}</span>
                                                <button type="button" mat-icon-button
                                                    (click)="clearApkFile(apkInput)"
                                                    matTooltip="Remove APK">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </div>

                                            <!-- "Set as suite default" checkbox — only after file is picked -->
                                            <mat-checkbox *ngIf="apkFile" name="setApkForSuite" [(ngModel)]="setApkForSuite"
                                                class="set-default-check">
                                                Set APK as suite default
                                            </mat-checkbox>

                                        </ng-container>
                                </div>
                            </ng-container>

                            </div>
                            <div class="exe_container_bottom">
                                <div class="exe_container_checkbox">
                                    <mat-checkbox class="check-box custom-checkbox" name="selenoidCheckbox"
                                        *ngIf="isWebExecution()" [(ngModel)]="executionModel.default_hub"
                                        (change)="onCheckboxChange()" [matTooltip]="'Run On ' + brand.brandName + ' Hub'">Run On {{brand.brandName}}
                                        Hub</mat-checkbox>
                                    <mat-checkbox class="check-box custom-checkbox" name="mobileHubCheckbox"
                                        *ngIf="isMobileExecution()" [(ngModel)]="runOnXpeerMobileHub"
                                        (change)="onMobileHubCheckboxChange()" [matTooltip]="'Run On ' + brand.brandName + ' Mobile Hub'">Run
                                        On {{brand.brandName}} Mobile
                                        Hub</mat-checkbox>
                                    <mat-checkbox class="check-box custom-checkbox" name="sendMailCheckbox"
                                        [(ngModel)]="executionModel.send_mail"
                                        matTooltip="Send Notification On Completion">Send
                                        Notification On
                                        Completion</mat-checkbox>

                                    <mat-checkbox class="check-box custom-checkbox" name="screenShotCheckbox"
                                        *ngIf="isWebExecution()" [(ngModel)]="executionModel.screenshot_required"
                                        matTooltip="Visual Comparison">Visual Comparison</mat-checkbox>

                                    <mat-checkbox class="check-box custom-checkbox" name="isImplicitDelayCheckbox"
                                        *ngIf="executionModel.default_pause != undefined && executionModel.default_pause !== '0'"
                                        [(ngModel)]="executionModel.is_implicit_default_pause"
                                        matTooltip="Implicit Delay">Implicit Delay</mat-checkbox>


                                </div>
                                <div class="btns">

                                    <button class="exe_btn exe_generate" mat-raised-button color="primary" (click)="hideDialog()"
                                        *ngIf="isParametersAvailable">Generate</button>

                                    <button *ngIf="!hideControls" class="exe_btn" mat-raised-button color="primary" (click)="execute()"
                                        [disabled]="isExecuteDisabled()">Execute</button>
                                    <button *ngIf="!hideControls" class="exe_btn" mat-raised-button (click)="reset()">Reset</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="back" *ngIf="showDialog">
    <div class="new">
        <div class="top">
            <p>Generate Parameter</p>
        </div>
        <div class="middle">
            <div class="inputBtn">
                <label>
                    <input type="radio" name="mode" [(ngModel)]="selectedMode" value="manual"
                        (change)="onModeChange()" />
                    Manual
                </label>
                <label>
                    <input type="radio" name="mode" [(ngModel)]="selectedMode" value="ai" (change)="onModeChange()" [disabled]="disableAi" />
                    AI
                </label>
            </div>

            <div>
                <label for="setTime">Set Limit:</label>
                <input id="setTime" type="text" [disabled]="isSetTimeDisabled" placeholder="Enter time"
                    [(ngModel)]="setLimit" />
            </div>

        </div>
        <div class="bottom">
            <div *ngIf="isAIGenerated && !hideDownloadAndFeedButton" class="ai-buttons">
                <button class="exe_btn" (click)="downloadAndFeedCSV()">Download and Feed</button>
            </div>
            <button class="exe_btn" (click)="downloadCsv()">Download</button>
            <button class="exe_btn" (click)="hideDialog()">Cancel</button>
        </div>
    </div>
</div>